export const GET_ALL_QUALITY_ASSURANCE_OBSERVATIONS = "GET_ALL_QUALITY_ASSURANCE_OBSERVATIONS";
export const RESET_DATA = "RESET_DATA";
export const START_LOADING_QUALITY_ASSURANCE_OBSERVATIONS = "START_LOADING_QUALITY_ASSURANCE_OBSERVATIONS";
export const STOP_LOADING_QUALITY_ASSURANCE_OBSERVATIONS = "STOP_LOADING_QUALITY_ASSURANCE_OBSERVATIONS";
export const ERROR_LOADING_QUALITY_ASSURANCE_OBSERVATIONS = "ERROR_LOADING_QUALITY_ASSURANCE_OBSERVATIONS";